import React from 'react';
import PropTypes from 'prop-types';
import {
  FastField,
  useFormikContext,
} from 'formik';
import {
  Checkbox,
  FormControlLabel,
} from '@mui/material';

import fieldName, { questionFieldName } from '../../../../formFields';
import QuestionType from '../../../../questionType';
import { FormType } from '../../../../../../Model/Form';
import texts from '../../../../texts';
import {
  Container,
  SingleRowContainer,
  ShortFormInput,
  LongFormInput,
} from '../styles';

const InputsWithoutPlaceholder = [
  QuestionType.DATE,
  QuestionType.PHONE,
];

const InputQuestion = ({
  index, formType, isCoachView, disabled,
}) => {
  const { values, setFieldValue } = useFormikContext();
  const isPostPaymentForm = formType === FormType.POST_PAYMENT;

  const fieldBaseName = `${fieldName.FIELDS}.${index}`;

  return (
    <Container>
      <SingleRowContainer>
        {!isCoachView && (
          <>
            <ShortFormInput
              name={`${fieldBaseName}.${questionFieldName.CUSTOM_CLASS}`}
              label={texts.labels[questionFieldName.CUSTOM_CLASS]}
              disabled={disabled}
            />
            <ShortFormInput
              name={`${fieldBaseName}.${questionFieldName.ID}`}
              label={texts.labels[questionFieldName.ID]}
              disabled={disabled}
            />
          </>
        )}
        <FastField name={`${fieldBaseName}.${questionFieldName.REQUIRED}`}>
          {({ field }) => (
            <FormControlLabel
              key={`${fieldBaseName}-${index}-${questionFieldName.REQUIRED}`}
              control={<Checkbox checked={field.value} />}
              label={texts.labels[questionFieldName.REQUIRED]}
              name={questionFieldName.REQUIRED}
              disabled={disabled}
              onChange={(event) => {
                setFieldValue(`${fieldBaseName}.${questionFieldName.REQUIRED}`, event.target.checked);
              }}
            />
          )}
        </FastField>
      </SingleRowContainer>
      <LongFormInput
        name={`${fieldBaseName}.${questionFieldName.LABEL}`}
        label={texts.labels[questionFieldName.LABEL]}
        disabled={disabled}
      />
      {isPostPaymentForm && (
        <LongFormInput
          name={`${fieldBaseName}.${questionFieldName.SUB_TEXT}`}
          label={texts.labels[questionFieldName.SUB_TEXT]}
          disabled={disabled}
        />
      )}
      {/* A placeholder field is not needed for several question types as they have their own placeholders */}
      {!InputsWithoutPlaceholder.includes(values[fieldName.FIELDS][index][questionFieldName.TYPE]) && (
        <LongFormInput
          name={`${fieldBaseName}.${questionFieldName.PLACEHOLDER}`}
          label={texts.labels[questionFieldName.PLACEHOLDER]}
          disabled={disabled}
        />
      )}
    </Container>
  );
};

InputQuestion.propTypes = {
  index: PropTypes.number.isRequired,
  formType: PropTypes.string.isRequired,
  isCoachView: PropTypes.bool,
  disabled: PropTypes.bool,
};

InputQuestion.defaultProps = {
  isCoachView: false,
  disabled: false,
};

export default InputQuestion;
